import CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME from '../../constants/form-control-label';

export const compactCheckboxStyle = {
  py: 0,
  '& .MuiSvgIcon-root': { fontSize: 20 },
  border: '0px',
};

export const cessionTypeFormControlLabelStyles = ({ theme, checkedColor }) => ({
  backgroundColor: theme.palette.gray.A100,
  border: '2px solid',
  borderColor: theme.palette.gray.A300,
  borderRadius: 16,
  padding: 16,
  justifyContent: 'space-between',
  '&:has(.Mui-checked)': {
    borderColor: checkedColor,
  },
});

const MuiFormControlLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${CESSION_TYPE_FORM_CONTROL_LABEL_CLASS_NAME}`]: cessionTypeFormControlLabelStyles({ theme, checkedColor: theme.palette.primary.main }),
    }),
  },
};

export default MuiFormControlLabel;
